// import { $combine } from '@type.engineering/type-engineer'
import { AbstractDep } from '../../types/lux'

export default AbstractDep

// /** @this {Dep} */
// function __$constructor() {

// }
// __$constructor[$combine] = true

/** @constructor @extends {AbstractDep} @suppress {checkTypes} */ function _Dep() {}
AbstractDep.__implement(
  _Dep.prototype = /** @type {!AbstractDep} */ ({
    __$constructor() {
      const { asIDep: { waitForDeps }, asIDep } = this
      asIDep.__$childConstructed = true
      setTimeout(() => {
        waitForDeps()
        // if - until maurice is updated to recognise controllers
        if (this.dispatchEvent) this.dispatchEvent(new Event(__$constructed)) // todo - do it after awaited for all deps
      }, 1) // allow other constructors to run and set .deps.
    },
    ready() {},
    waitForDeps() {
      const { asIDep: { ready } } = this
      const Deps = []
      const{asIDep:{deps=[]}}=this
      for (const dep of deps) {
        if (dep.__$childConstructed) continue
        Deps.push(dep)
        const cb = () => {
          const { deps: d } = this
          d.splice(d.indexOf(dep), 1)
          if (!d.length) {
            ready()
          }
          dep.removeEventListener(__$constructed, cb)
        }
        dep.addEventListener(__$constructed, cb)
      }
      this.deps = Deps
      if (!Deps.length) ready()
    },
  }),
)

/** @noinline */
const __$constructed = '__$constructed'